import { Grid, Tooltip } from "@mui/material";
import { MxJiraCustomComponentProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { AutoCompleteItemOption } from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";
import MxTypography from "@rf-l1/MxTypography";
import { ownerAutoCompleteItem } from "@rf/adapters/autocomplete-items/ownerItemAdapters";
import { IconFlagFilled } from "@tabler/icons-react";

const MxItemOwnerWithConflict = (
  props: MxJiraCustomComponentProps<ownerAutoCompleteItem>
) => {
  const { item, ...rest } = props;
  return (
    <AutoCompleteItemOption {...rest}>
      <Grid container justifyContent={"space-between"} alignItems={"center"}>
        <Grid item xs={"auto"}>
          <MxTypography variant="overline" width={350} color="grey.600" lines={1}>
            {item.extraData?.ownerData?.name}
          </MxTypography>
        </Grid>
        <Grid item xs={"auto"}>
          {Boolean(item?.extraData?.ownerData?.isConflictive) && (
            <Tooltip title="">
              <IconFlagFilled
                style={{
                  fill: "#dc1d2d",
                  width: "16px",
                  height: "16px"
                }}
              />
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </AutoCompleteItemOption>
  );
};

export default MxItemOwnerWithConflict;
